export default class DtoPiezometerKeyFigure {
	constructor(obj) {
		this.qualitometerId = obj.stationid
		this.nbAnalysis = obj.nbanalysis
		this.analysisFirstDate = obj.analysisfirstdate
		this.analysisLastDate = obj.analysislastdate
		this.nbOperation = obj.nboperations
		this.operationFirstDate = obj.operationfirstdate
		this.operationLastDate = obj.operationlastdate
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoQualitometerKeyFigure.js